import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductSelector, { ProductSelectorStyles } from "@waytek/Overrides/Components/ProductSelector";
import { CustomState } from "@waytek/Store/Reducers";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const { productSelectQty, isLoadingMultipleProducts } = state.productInformationState;
    return { productSelectQty, isLoadingMultipleProducts };
};

const mapDispatchToProps = {};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & HasHistory;

export interface QuickOrderSearchForDesktopStyles {
    wrapper?: InjectableCss;
    productSelector?: ProductSelectorStyles;
}

export const quickOrderSearchForDesktopStyles: QuickOrderSearchForDesktopStyles = {
    productSelector: {
        searchGridItem: {
            width: 12,
        },
        qtyGridItem: {
            width: 12,
        },
        unitOfMeasureGridItem: {
            width: 0,
            css: css`
                display: none;
            `,
        },
        buttonGridItem: {
            width: 0,
            css: css`
                display: none;
            `,
        },
    },
};

const styles = quickOrderSearchForDesktopStyles;

const QuickOrderSearchForDesktop = ({ productSelectQty, isLoadingMultipleProducts }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductSelector
                onSelectProduct={() => {}}
                productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
                productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
                extendedStyles={styles.productSelector}
                validateMinMultiplier={true}
                qtyValue={productSelectQty ?? -1}
                hideSelector={isLoadingMultipleProducts}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withHistory(QuickOrderSearchForDesktop as any) as any) as any,
    definition: {
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
        displayName: "Search [For Desktop]",
    },
};

export default widgetModule;
